import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useMutation, useQuery } from "react-query";
import { token } from "auth";


export function useTopics() {
  const uploadAudioFiles = useMutation(async ({ id, fileData }) => {
    if (!fileData || fileData.length === 0) {
      throw new Error("No files provided.");
    }

    const formData = new FormData();

    fileData.forEach((file) => {

      formData.append("file", file);
    });

    const response = await makeAuthedRequest(`v1/settings/topics/${id}`, {
      method: "POST",
      body: formData,
      disableDefaultHeaders: true,
    });

    if (response.ok) {
      const responseBody = await response.json();

      return responseBody;
    } else {
      const errorText = await response.text();
      console.error("Error response:", errorText);
      throw new Error("Upload failed: " + errorText);
    }
  });

  const { data: uploadedAudioFiles, isLoading: uploadedAudioFilesLoading, refetch: refetchUploadedAudioFiles, isFetching: refetchingUploadedAudioFilesLoading } = useQuery(
    ["CurrentUploads"],
    () =>
      makeAuthedRequest("v1/settings/topics/currentUploads", {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error((await res.json()).message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  const retryUploadForItem = useMutation((retryItem) =>
    makeAuthedRequest(`v1/settings/topicsRetry/upload`, {
      method: "POST",
      body: JSON.stringify(retryItem),
    }).then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  // const { data: uploadedAudioFiles, isLoading: uploadedAudioFilesLoading, refetch: refetchUploadedAudioFiles, isFetching: refetchingUploadedAudioFilesLoading } = useQuery({
  //   queryKey: ["CurrentUploads"],
  //   queryFn: async () => {
  //     const res = await fetch("http://localhost:7071/api/topics/currentUploads", {
  //       method: "GET",
  //       headers: {
  //         "wwg-token": token
  //       }
  //     });

  //     if (!res.ok) {
  //       throw new Error("Failed to fetch audio list");
  //     }

  //     return res.json();
  //   },
  //   enabled: false
  // });


  return {
    uploadAudioFiles,

    uploadedAudioFiles,
    uploadedAudioFilesLoading,
    refetchUploadedAudioFiles,
    refetchingUploadedAudioFilesLoading,

    retryUploadForItem
  };
}